const DOCUMENT_TRACKING_ROUTE = '/document-tracking'

export { DOCUMENT_TRACKING_ROUTE }
